import React from 'react';
import lpLogo from '../imgs/lp_pro.svg';

/** Small looping truck that drives across the settings hero. */
const SettingsTruck: React.FC = () => {
  return (
    <div className="settings-truck" aria-hidden="true">
      <div className="settings-truck__lane">
        <div className="settings-truck__mover">
          <div className="settings-truck__body">
            <span className="settings-truck__wind" style={{ width: 8, top: 10, left: -4, animationDelay: '0s' }} />
            <span className="settings-truck__wind" style={{ width: 5, top: 14, left: -8, animationDelay: '0.25s' }} />
            <span className="settings-truck__wind" style={{ width: 9, top: 18, left: -6, animationDelay: '0.5s' }} />
            <svg width="56" height="26" viewBox="0 0 90 32" fill="none">
              <rect x="0" y="2" width="58" height="22" rx="2" fill="#f2f2f2" />
              <rect x="0" y="2" width="58" height="4" rx="2" fill="#ddd" />
              <rect x="0" y="22" width="58" height="2" rx="1" fill="#ddd" />
              <image
                href={lpLogo}
                x="6"
                y="4"
                width="46"
                height="16"
                preserveAspectRatio="xMidYMid meet"
              />
              <rect x="58" y="8" width="2" height="12" fill="#111" />
              <rect x="60" y="4" width="20" height="20" rx="2" fill="#fff" />
              <rect x="62" y="6" width="14" height="10" rx="1" fill="#b8d4e8" opacity="0.85" />
              <rect x="74" y="14" width="10" height="10" rx="1" fill="#e8e8e8" />
              <rect x="75" y="20" width="8" height="4" rx="1" fill="#ccc" />
              <circle cx="76" cy="16" r="2" fill="#FFE97A" />
              <circle cx="81" cy="16" r="2" fill="#fff" opacity="0.5" />
              <circle cx="10" cy="29" r="4" fill="#111" />
              <circle cx="10" cy="29" r="1.5" fill="#555" />
              <circle cx="24" cy="29" r="4" fill="#111" />
              <circle cx="24" cy="29" r="1.5" fill="#555" />
              <circle cx="70" cy="29" r="4" fill="#111" />
              <circle cx="70" cy="29" r="1.5" fill="#555" />
              <circle cx="80" cy="29" r="4" fill="#111" />
              <circle cx="80" cy="29" r="1.5" fill="#555" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTruck;
